import { render, staticRenderFns } from "./performanceForm.vue?vue&type=template&id=552806be&"
import script from "./performanceForm.vue?vue&type=script&lang=js&"
export * from "./performanceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports